export const getPerdiemRequestApprovals = (state) =>
  state.perdiemRequestApprovals.results;